import { Undo } from '@mui/icons-material';
import { Button, Tooltip } from '@mui/material';
import { useState } from 'react';
import useEventListener from '~/hooks/useEventListener';
import useViewportEnvironment from '~/hooks/useViewportEnvironment';

type UndoContouringButtonProps = {
    disabled?: boolean;
};

const UndoContouringButton = ({ disabled }: UndoContouringButtonProps) => {
    const { environment } = useViewportEnvironment();
    const undoContouring = () => {
        environment?.undoContouring();
    };

    const [canUndo, setCanUndo] = useState(false);

    const handleStructureSetChange = () => {
        setCanUndo(environment?.canUndoContouring() ?? false);
    };

    useEventListener(
        'structure_set_property_changed',
        handleStructureSetChange,
        environment?.eventTarget
    );

    return (
        <Button
            size="small"
            value="undo-contouring"
            onClick={() => {
                undoContouring();
            }}
            disabled={!canUndo || disabled}
        >
            <Tooltip title="Undo contour">
                <Undo />
            </Tooltip>
        </Button>
    );
};

export default UndoContouringButton;
